module.exports = "<wow-tobacco-banner ng-if=\"$ctrl.pageBannerStateService.getPageBannerState().setTobaccoBanner\"></wow-tobacco-banner>\r\n\r\n<ng-transclude></ng-transclude>\r\n\r\n<wow-tobacco-banner ng-if=\"$ctrl.pageBannerStateService.getPageBannerState().setTobaccoBanner\"></wow-tobacco-banner>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shop/tiles/tile-list-with-content.component.html
// module id = 274
// module chunks = 0 2